export default {"src":"https://fishbrain.com/_next/static/media/utah.a8abccaf.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};